export const getOrigin = (): string => {
	return window.location.origin;
};
